import React, {useEffect, useState}  from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Checkbox from "@material-ui/core/Checkbox";

// material-ui icons
import Assignment from "@material-ui/icons/Assignment";
import Person from "@material-ui/icons/Person";
import Edit from "@material-ui/icons/Edit";
import Close from "@material-ui/icons/Close";
import Check from "@material-ui/icons/Check";
import Remove from "@material-ui/icons/Remove";
import Add from "@material-ui/icons/Add";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Table from "components/Table/Table.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardIcon from "components/Card/CardIcon.js";
import CardHeader from "components/Card/CardHeader.js";
import SweetAlert from "react-bootstrap-sweetalert";

import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import styles_alert from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";

import product1 from "assets/img/product1.jpg";
import product2 from "assets/img/product2.jpg";
import product3 from "assets/img/product3.jpg";
import axios from 'axios';
import { Link, Redirect } from "react-router-dom";

const useStyles = makeStyles(styles);

const useStyles_alert = makeStyles(styles_alert);

export default function UsersTable() {


  const [redirctTo, setRedirctTo] = useState(false);

  const [Users, setUsers] = useState([])

  const [alert, setAlert] = React.useState(null);

  const [update_id, setupdate_id] = useState("0")
  const [token_logged, settoken_logged] = React.useState("");
   
  useEffect(() => {
      document.getElementById("test_id").innerHTML = "Users";
      const local_login = localStorage.getItem('local_login')
      let token = "";
      if(local_login){
        try {
          const getToken = async () => {
            const res = await axios.post('/user/refresh_token', null)
            
            token = res.data.access_token;

            settoken_logged(token);

            const res2 = await axios.get('/user/infor', {
              headers: {Authorization: token}
            })     

            const res3 = await axios.get('/user/all_infor', {
              headers: {Authorization: token}
            })  

            console.log(res3.data)

            setUsers(res3.data)
            
            
            
          }
          getToken()
        } catch (err) {
          setRedirctTo(true);
        } 
      }else{
        setRedirctTo(true)
      }
    
}, [  ]);


  const [checked, setChecked] = React.useState([]);
  const handleToggle = value => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    setChecked(newChecked);
  };
  const classes = useStyles();
  const classes_alert = useStyles_alert();
  const fillButtons = (id) => (     
      <Button  onClick={(e)=>warningWithConfirmAndCancelMessage(id,e)} color="danger" className={classes.actionButton} key={id} >
        <Close className={classes.icon} />
      </Button>
  );
  const simpleButtons = [
    { color: "info", icon: Person },
    { color: "success", icon: Edit },
    { color: "danger", icon: Close }
  ].map((prop, key) => {
    return (
      <Button
        color={prop.color}
        simple
        className={classes.actionButton}
        key={key}
      >
        <prop.icon className={classes.icon} />
      </Button>
    );
  });
  const roundButtons = [
    { color: "info", icon: Person },
    { color: "success", icon: Edit },
    { color: "danger", icon: Close }
  ].map((prop, key) => {
    return (
      <Button
        round
        color={prop.color}
        className={classes.actionButton + " " + classes.actionButtonRound}
        key={key}
      >
        <prop.icon className={classes.icon} />
      </Button>
    );
  });

  let datatable1 = [];

  for (let index = 0; index < Users.length; index++) {
    let role_text = "";
    if(Users[index].role == "1"){
      role_text = "All";
    }
    if(Users[index].role == "2"){
      role_text = "Administrator";
    }
    if(Users[index].role == "3"){
      role_text = "Technician App";
    }
    let user_item = [ "/admin/edit-user/"+Users[index]._id, Users[index].name,role_text,formatDate(Users[index].createdAt),fillButtons(Users[index]._id) ];
    datatable1.push(user_item);
  }
  

  const datatable = datatable1

  if (redirctTo){
    return <Redirect to='/auth/login-page'  />
  }

  function formatDate(string){
      var options = { year: 'numeric', month: 'long', day: 'numeric' };
      return new Date(string).toLocaleDateString([],options);
  }


  const warningWithConfirmAndCancelMessage = (id,e) =>    {
    //console.log(id);
    //setupdate_id(id);
    setAlert(
      <SweetAlert
        warning
        style={{ display: "block", marginTop: "-100px" }}
        title="Are you sure?"
        onConfirm={() => successDelete(id)}
        onCancel={() => cancelDetele()}
        confirmBtnCssClass={classes_alert.button + " " + classes_alert.success}
        cancelBtnCssClass={classes_alert.button + " " + classes_alert.danger}
        confirmBtnText="Yes, delete it!"
        cancelBtnText="Cancel"
        showCancel
      >
        
      </SweetAlert>
    );
    e.stopPropagation();
  };

  const cancelDetele = () => {
    setAlert(
      <SweetAlert
        danger
        style={{ display: "block", marginTop: "-100px" }}
        title="Cancelled"
        onConfirm={() => hideAlert()}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classes_alert.button + " " + classes_alert.success}
      >
        
      </SweetAlert>
    );
  };

  const successDelete =  async (id) => {
    try {

      const res = await axios.delete('/user/delete/' + id, {
        headers: {Authorization: token_logged}
      })

      //console.log(res.data.msg);

      window.location.reload(false);

      //setRedirctTo_new_user(true);

    } catch (err) {
        //err.response.data.msg &&
        //setUser({...user, err: err.response.data.msg, success: ''})
    }

    setAlert(
      <SweetAlert
        success
        style={{ display: "block", marginTop: "-100px" }}
        title="Deleted!"
        onConfirm={() => hideAlert()}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classes_alert.button + " " + classes_alert.success}
      >

      </SweetAlert>
    );
  };

  const hideAlert = () => {
    setAlert(null);
  };
  
  
  return (
    <GridContainer>
      {alert}
      <GridItem xs={12}>
        <div className={classes.right}>
          <Link to="/admin/new-user">
            <Button color="rose" className={classes.right}>
                Create New User
            </Button>
          </Link>
        </div>
        <Card>          
          <CardHeader color="rose" icon>
            <CardIcon color="rose">
              <Assignment />
            </CardIcon>
            <h4 className={classes.cardIconTitle}></h4>
          </CardHeader>
          <CardBody>
            
            <Table
              hover
              tableHead={[
                "Full Name",
                "Access",
                "Generated",
                ""
              ]}
              tableData={datatable
              }
              customCellClasses={[classes.left, classes.left, classes.left]}
              customClassesForCells={[0, 4, 5]}
              customHeadCellClasses={[
                classes.left,
                classes.left,
                classes.left
              ]}
              customHeadClassesForCells={[0, 4, 5]}
            />
          </CardBody>
        </Card>
      </GridItem>
    
    </GridContainer>
  );
}
